/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Theme, useTheme } from 'bold-ui'

export function ConsultaSeguimentoArrowDown() {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <svg width='16' height='32' viewBox='0 0 16 32' fill='none' xmlns='http://www.w3.org/2000/svg' css={styles.svg}>
      <path
        d='M8.99978 -3.65603e-07L8.99978 28.5859L13.657 23.9287C14.0476 23.5385 14.6806 23.5383 15.0711 23.9287C15.4615 24.3191 15.4613 24.9522 15.0711 25.3428L8.70681 31.707C8.31628 32.0976 7.68327 32.0976 7.29275 31.707L0.928488 25.3428C0.53826 24.9522 0.538063 24.3191 0.928488 23.9287C1.31891 23.5383 1.952 23.5385 2.34255 23.9287L6.99978 28.5859L6.99978 -2.7818e-07L8.99978 -3.65603e-07Z'
        fill='currentColor'
      />
    </svg>
  )
}

const createStyles = (theme: Theme) => ({
  svg: css`
    color: ${theme.pallete.primary.c60};
    display: grid;
    justify-self: center;
    justify-items: center;
  `,
})
